import {
  CustomAttributeEntityType,
  FieldDataType,
  FieldConstraintsInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const customAttributeCreateMutationAtom = createMutationAtomFactory(
  'settings.customAttributeCreate',
  (params: {
    name: string;
    dataType: FieldDataType;
    entityType: CustomAttributeEntityType;
    constraints: FieldConstraintsInput;
    order: number;
  }) => ({
    coreCustomAttributeCreate: {
      __args: {
        input: {
          name: params.name,
          constraints: params.constraints,
          order: params.order,
          dataType: params.dataType,
          entityType: params.entityType,
        },
      },
      id: true,
    },
  }),
);
